module.exports = __webpack_public_path__ + "img/portrait-equipe.88e4c4d4.png";